module.exports = __webpack_public_path__ + "static/media/codGradient.b70b8403.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/codGradient.png
// module id = 88
// module chunks = 0